'use client';

import React, { type ReactNode } from 'react';
import {
  getLocalStorageVisitorToken,
  setLocalStorageVisitorToken,
} from './visitor-token';

export function VisitorTokenStorageLoader({
  children,
  newlyGeneratedServerToken,
}: {
  children: ReactNode;
  newlyGeneratedServerToken: string | null;
}) {
  const localStorageVisitorToken = getLocalStorageVisitorToken();
  if (!localStorageVisitorToken && newlyGeneratedServerToken) {
    setLocalStorageVisitorToken(newlyGeneratedServerToken);
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
